import * as React from 'react';

interface Observer {
  disconnect(): void;
  observe(target: Element): void;
}

export function useObserver<T extends Observer>(observer: T) {
  const ref = React.useRef<HTMLElement | null>(null);

  const observe = React.useCallback((element: HTMLElement | null) => {
    observer.disconnect();
    if (element) {
      observer.observe(element);
    }
    ref.current = element;
  }, [observer]);

  React.useEffect(() => {
    if (ref.current) {
      observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [observer]);

  return observe;
}
